module.exports = __webpack_public_path__ + "static/media/previousPage.ff2f70d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/previousPage.svg
// module id = 2456
// module chunks = 0